import { Wallet, CreditCard, ArrowRight, TrendingDown, TrendingUp } from 'lucide-react';

export default function OperationalActionButtons({ onIncomeClick, onExpenseClick }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Gelir Ekle Butonu - Yeşil */}
            <button
                onClick={onIncomeClick}
                className="group relative overflow-hidden rounded-2xl bg-[#059669] hover:bg-[#047857] transition-all duration-300 shadow-md hover:shadow-xl hover:shadow-success/20 hover:-translate-y-1 active:translate-y-0"
            >
                {/* Arkaplan Deseni */}
                <div className="absolute inset-0 bg-[url('/patterns/noise.png')] opacity-10 mix-blend-overlay" />
                <div className="absolute -right-20 -top-20 w-64 h-64 bg-white/10 rounded-full blur-3xl group-hover:bg-white/20 transition-all duration-500" />

                <div className="relative z-10 flex items-center justify-between p-6 md:p-8">
                    <div className="flex items-center gap-5 md:gap-6">
                        <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center shadow-inner group-hover:scale-110 transition-transform duration-300 border border-white/10">
                            <TrendingUp size={32} className="text-white" strokeWidth={2.5} />
                        </div>
                        <div className="text-left space-y-1">
                            <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight">Gelir Ekle</h3>
                            <p className="text-sm md:text-base text-white/90 font-medium">Satış veya Tahsilat Girişi</p>
                        </div>
                    </div>
                    <div className="hidden sm:flex w-10 h-10 rounded-full bg-white/10 items-center justify-center group-hover:bg-white group-hover:text-[#059669] transition-all duration-300 transform group-hover:translate-x-2 border border-white/10">
                        <ArrowRight size={20} />
                    </div>
                </div>
            </button>

            {/* Gider Ekle Butonu - Kırmızı */}
            <button
                onClick={onExpenseClick}
                className="group relative overflow-hidden rounded-2xl bg-[#dc2626] hover:bg-[#b91c1c] transition-all duration-300 shadow-md hover:shadow-xl hover:shadow-error/20 hover:-translate-y-1 active:translate-y-0"
            >
                {/* Arkaplan Deseni */}
                <div className="absolute inset-0 bg-[url('/patterns/noise.png')] opacity-10 mix-blend-overlay" />
                <div className="absolute -right-20 -top-20 w-64 h-64 bg-white/10 rounded-full blur-3xl group-hover:bg-white/20 transition-all duration-500" />

                <div className="relative z-10 flex items-center justify-between p-6 md:p-8">
                    <div className="flex items-center gap-5 md:gap-6">
                        <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center shadow-inner group-hover:scale-110 transition-transform duration-300 border border-white/10">
                            <TrendingDown size={32} className="text-white" strokeWidth={2.5} />
                        </div>
                        <div className="text-left space-y-1">
                            <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight">Gider Ekle</h3>
                            <p className="text-sm md:text-base text-white/90 font-medium">Harcama veya Ödeme Çıkışı</p>
                        </div>
                    </div>
                    <div className="hidden sm:flex w-10 h-10 rounded-full bg-white/10 items-center justify-center group-hover:bg-white group-hover:text-[#dc2626] transition-all duration-300 transform group-hover:translate-x-2 border border-white/10">
                        <ArrowRight size={20} />
                    </div>
                </div>
            </button>
        </div>
    );
}
